import advancedFormat from 'dayjs/plugin/advancedFormat';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { clsx, type ClassValue } from 'clsx';

import { composeRenderProps } from 'react-aria-components';
import { tv } from 'tailwind-variants';
import { twMerge } from 'tailwind-merge';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(advancedFormat);

export const formattedDateAndTime = (
  date: string | number | Date | dayjs.Dayjs | null | undefined,
) => dayjs(date).format('MM/DD/YYYY @ h:mmA z');

export const isWithin24Hours = (incomingDate: Date) => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const incoming = new Date(incomingDate);
  return incoming > yesterday;
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// eslint-disable typescript-eslint/no-shadow
export function composeTailwindRenderProps<T>(
  className: string | ((v: T) => string) | undefined,
  tw: string,
): string | ((v: T) => string) {
  return composeRenderProps(className, (className) => twMerge(tw, className));
}

export const focusRing = tv({
  base: 'outline outline-blue-600 dark:outline-blue-500 forced-colors:outline-[Highlight] outline-offset-2',
  variants: {
    isFocusVisible: {
      false: 'outline-0',
      true: 'outline-2',
    },
  },
});
